import { accountsUtils } from 'app-components/flux/accounts';
import type { AccountProps } from 'app-components/flux/accounts/accountsTypes';

import type { MatchableAccount } from './merchantOrderMatch';

/**
 * Converts accounts into the shape the matcher scopes by. The one place `AccountProps` and its
 * Immutable internals are allowed near this module — the matcher itself stays plain objects so it
 * can be tested from literals and shared with mobile.
 *
 * Accounts with no digits are dropped rather than passed through empty: an account that cannot be
 * identified should not silently swallow a scope.
 */
export const toMatchableAccounts = (accounts: AccountProps[]): MatchableAccount[] =>
  accounts.flatMap((account) => {
    const finalFourDigits = accountsUtils.getAccountFinalFourDigits(account);
    return account.id && finalFourDigits ? [{ id: account.id, finalFourDigits }] : [];
  });
